<template>
  <div class="module_number">
    <div class="module_number_gongyong module_number_one">{{ title }}</div>
    <div class="module_number_gongyong">
      <span class="number">{{ currentId }}</span>
      <span class="number">/</span>
      <span class="number totals">{{ totals }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CapsuleProgress",
  props: {
    title: {
      type: String,
      default: '进度',
    },
    currentId: {
      type: Number,
      default: 0,
    },
    totals: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="less">
.module_number {
  position: relative;
  text-align: center;
  background-color: @primary-color;
  color: #fff;
  z-index: 2;
  display: flex;
  border: 3px solid @primary-color;
  border-radius: 5px;
  font-size: 14px;
  .module_number_one {
    background: #fff;
    color: @primary-color;
  }
  .module_number_gongyong {
    padding: 5px 15px;
  }
  .number {
    float: left;
    margin: 0 2px;
  }
  .totals {
    float: right;
  }
}
</style>
